<template>
	<div class="row" id="result" v-show="display">
        <div class="row" id="bilanTableHeader">
            <span>Paiement à distance</span>
            <span class="pull-right">{{formattedInfos.tot}}</span>
            <sup>€</sup>
        </div>
        <div class="row" id="bilanTable">
            <div class="col-md-6 col-xs-12 col-sm-12 profit">
                <div class="row">
                    <span>Payé</span>
                    <span class="pull-right">{{formattedInfos.paid}}</span>
                    <sup>€</sup>
                </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12 expense">
                <div class="row">
                    <span>En cours</span>
                    <span class="pull-right">{{formattedInfos.standby}}</span>
                    <sup>€</sup>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	export default {
		name: 'bilanPaiement',
		props: {
			info : Object
		},
		data () {
			return {
				formattedInfos:{},
				display:false
			}
		},
		mounted: function () {
			this.show()
		},
		methods:{
			show:function(){
				this.$nextTick(() => {//wait for this.info to update
					for (let [key, value] of Object.entries(this.info)) {
					  this.formattedInfos[key]=value.toLocaleString(undefined,{'minimumFractionDigits':2,'maximumFractionDigits':2})//"en" to prevent counter up to go too high
					}
					this.display=true
				});	
			},
		}
	}
</script>
<style type="text/css">
	#result{
		margin: 2em 0;
        width:100%;
	}
	#result sup{
		font-size: 14px
	}
	#result>div{
        width: 100%;
	}
	#bilanTableHeader{
		background-color: #70a6b285;
		display: flex;
		align-items: center;
		padding: 1em;
		border-top-right-radius: 3px!important;
		border-top-left-radius: 3px!important;
		margin: 0;
	}
	#bilanTableHeader span:first-child{
		font-size: 2.5rem;
		color: #444
	}
	#bilanTableHeader span:nth-child(2){
		font-size: 200%;
		text-align: right;
       	flex-grow: 1;
	}
	.profit div:nth-child(even){
		background-color: #6cb18285;
	}
	.profit div:nth-child(odd){
		background-color: #468b5c85;
	}
	.expense div:nth-child(even){
		background-color: #c9857085;
	}
	.expense div:nth-child(odd){
		background-color: #e3917985; 
	}
	#bilanTable{
		margin: 0;
	}
	#bilanTable>div>div{
		padding: 1em;
		display: flex;
		align-items: center;
	}
	#bilanTable>div>div span:first-child{
		font-size: 18px;
		color: #555
	}
	#bilanTable>div>div span:nth-child(2){
		font-size: 27px;
		text-align: right;
        flex-grow: 1;
	}
	.profit div:last-child{
		border-bottom-left-radius: 3px !important
	}
	.expense div:last-child{
		border-bottom-right-radius: 3px !important
	}
	@media(max-width: 767px){
		#bilanTableHeader span:first-child{
			font-size: 2rem;
		}
		#bilanTableHeader span:nth-child(2){
			font-size: 150%;
		}
		#bilanTable>div>div span:first-child{
			font-size: 15px;
		}
		#bilanTable>div>div span:nth-child(2){
			font-size: 20px;
		}
	}
</style>